import { Component } from '@angular/core';
import { ApiService } from '../services/api.service';
import { PlanComponent } from '../plan/plan.component';
import { ToastService } from '../services/toast.service';
import { LoadingService } from '../services/loading.service';

declare var bootstrap: any;

@Component({
  selector: 'app-plan-modal',
  templateUrl: './plan-modal.component.html',
  styleUrl: './plan-modal.component.css',
})
export class PlanModalComponent {
  nuevoPlan: any = {
    id: '',
    descripcion: '',
    importeDesde: null,
    importeHasta: null,
    activo: null,
  };

  modoEditar: boolean = false;
  errores: { [key: string]: string } = {};
  mensajeNotificacion: string = '';
  tipoNotificacion: 'success' | 'error' = 'success';

  constructor(
    private apiSrv: ApiService,
    private planComponent: PlanComponent,
    private toastSrv: ToastService,
    public loadingSrv: LoadingService
  ) {}

  abrirModoCreacionPlan(): void {
    const modalElement = document.getElementById('nuevoPlanModal');
    if (modalElement) {
      this.modoEditar = false;
      this.nuevoPlan = {
        id: '',
        descripcion: '',
        importeDesde: null,
        importeHasta: null,
        activo: null,
      };
      this.errores = {};
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
    }
  }

  abrirModoEdicionPlan(plan: any): void {
    this.modoEditar = true;
    this.setPlanData(
      plan.id,
      plan.descripcion,
      plan.importeDesde,
      plan.importeHasta,
      plan.activo
    );
    const modalElement = document.getElementById('nuevoPlanModal');
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
    }
  }

  setPlanData(
    id: number,
    descripcion: string,
    importeDesde: number,
    importeHasta: number,
    activo: boolean
  ): void {
    this.nuevoPlan.id = id;
    this.nuevoPlan.descripcion = descripcion;
    this.nuevoPlan.importeDesde = importeDesde;
    this.nuevoPlan.importeHasta = importeHasta;
    this.nuevoPlan.activo = activo;
  }

  agregarPlan(): void {
    if (this.validarNuevoPlan()) {
      this.loadingSrv.setLoading(true);
      this.apiSrv.guardarPlan(this.nuevoPlan).subscribe({
        next: () => {
          this.loadingSrv.setLoading(false);
          this.toastSrv.mostrarNotificacion(
            'Plan guardado correctamente.',
            'success'
          );
          this.nuevoPlan = {
            descripcion: '',
            importeDesde: null,
            importeHasta: null,
          };
          this.cerrarModal();
          this.planComponent.recargarTabla();
        },
        error: (error) => {
          this.loadingSrv.setLoading(false);
          this.toastSrv.mostrarNotificacion(
            'Ocurrió un error al guardar el plan.',
            'error'
          );
        },
      });
    }
  }

  actualizarPlan(): void {
    if (this.validarNuevoPlan()) {
      this.loadingSrv.setLoading(true);
      this.apiSrv.actualizarPlan(this.nuevoPlan).subscribe({
        next: () => {
          this.loadingSrv.setLoading(false);
          this.toastSrv.mostrarNotificacion(
            'Plan actualizado correctamente.',
            'success'
          );
          this.nuevoPlan = {
            id: '',
            descripcion: '',
            importeDesde: null,
            importeHasta: null,
            activo: null,
          };
          this.cerrarModal();
          this.planComponent.recargarTabla();
        },
        error: (error) => {
          this.loadingSrv.setLoading(false);
          this.toastSrv.mostrarNotificacion(
            'Ocurrió un error al actualizar el plan.',
            'error'
          );
        },
      });
    }
  }

  eliminarPlan(idPlan: number): void {
    this.loadingSrv.setLoading(true);
    this.apiSrv.eliminarPlan(idPlan).subscribe({
      next: (response) => {
        this.loadingSrv.setLoading(false);
        if (response.length > 0) {
          this.cerrarModal();
          this.toastSrv.mostrarNotificacion(
            '<strong>No se pudo eliminar el plan.</strong><br>Este plan está asignado a una persona.',
            'warning'
          );
        } else {
          this.planComponent.recargarTabla();
          this.cerrarModal();
          this.toastSrv.mostrarNotificacion(
            'Plan eliminado correctamente.',
            'success'
          );
        }
      },
      error: (error: any) => {
        this.loadingSrv.setLoading(false);
        this.toastSrv.mostrarNotificacion(
          'Ocurrió un error al eliminar el plan.' + error?.error,
          'error'
        );
      },
    });
  }

  private validarNuevoPlan(): boolean {
    this.errores = {};

    if (!this.nuevoPlan.descripcion) {
      this.errores['descripcion'] = 'El campo Descripción es obligatorio.';
    }

    if (!this.esNumero(this.nuevoPlan.importeDesde)) {
      this.errores['importeDesde'] =
        'El campo Importe Desde debe contener solo números.';
    }

    if (!this.esNumero(this.nuevoPlan.importeHasta)) {
      this.errores['importeHasta'] =
        'El campo Importe Hasta debe contener solo números.';
    }

    return Object.keys(this.errores).length === 0;
  }

  private esNumero(valor: any): boolean {
    return /^[0-9]+([.,][0-9]+)?$/.test(valor);
  }

  private cerrarModal(): void {
    const modalElement = document.getElementById('nuevoPlanModal');
    if (modalElement) {
      const modal = bootstrap.Modal.getInstance(modalElement);
      modal?.hide();
    }

    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
      backdrop.parentNode?.removeChild(backdrop);
    }
  }
}
